export default __webpack_public_path__ + "static/index_mission_product-51adc866182dfe0fc406d3a63c1a1129.jpg";